// Phase 1A Step 34 — Modular bundle pricing card.
// Verbatim port from handoff/landing-reference/expansion.jsx BundleCard.

import { type Bundle, type Currency } from "./landing-data.ts";

interface BundleCardProps {
  b: Bundle;
  currency: Currency;
}

export function BundleCard({ b, currency }: BundleCardProps): JSX.Element {
  const sym = currency === "GHS" ? "GH₵" : "₦";
  const price = b.prices[currency];
  const featured = b.featured ?? false;
  return (
    <div
      style={{
        position: "relative",
        background: "var(--surface)",
        border: featured ? "1px solid var(--accent)" : "1px solid var(--border)",
        padding: "32px 28px 28px",
        transform: featured ? "translateY(-12px)" : "none",
        boxShadow: featured ? "0 30px 80px rgba(212, 168, 67, 0.08)" : "none",
      }}
    >
      {featured && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            padding: "8px 0",
            background: "var(--accent)",
            color: "#0A0A0A",
            textAlign: "center",
            transform: "translateY(-100%)",
            fontFamily: "var(--mono)",
            fontSize: 10,
            letterSpacing: "0.18em",
            fontWeight: 600,
            textTransform: "uppercase",
          }}
        >
          Best value
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: 16,
        }}
      >
        <div className="display" style={{ fontSize: 28, color: "var(--text)" }}>
          {b.name}
        </div>
        <div
          className="mono"
          style={{
            fontSize: 9,
            letterSpacing: "0.16em",
            color: featured ? "var(--accent)" : "var(--text-dim)",
            textTransform: "uppercase",
          }}
        >
          {b.tag}
        </div>
      </div>
      <p
        style={{
          fontSize: 13,
          color: "var(--text-muted)",
          lineHeight: 1.55,
          marginBottom: 22,
          minHeight: 60,
        }}
      >
        {b.tagline}
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: 6,
          paddingBottom: 18,
          borderBottom: "1px solid var(--border)",
          marginBottom: 18,
        }}
      >
        <span className="mono" style={{ fontSize: 14, color: "var(--text-muted)" }}>
          {sym}
        </span>
        <span
          className="display"
          style={{
            fontSize: 52,
            color: featured ? "var(--accent)" : "var(--text)",
            lineHeight: 0.9,
          }}
        >
          {price.toLocaleString()}
        </span>
        <span
          className="mono"
          style={{
            fontSize: 10,
            letterSpacing: "0.14em",
            color: "var(--text-muted)",
            textTransform: "uppercase",
            marginLeft: 4,
          }}
        >
          / mo
        </span>
      </div>
      {b.save && currency === "GHS" && (
        <div
          className="mono"
          style={{
            fontSize: 10,
            letterSpacing: "0.14em",
            color: "var(--success)",
            textTransform: "uppercase",
            marginBottom: 16,
            fontWeight: 500,
          }}
        >
          · Save {sym}
          {b.save.GHS} vs individual
        </div>
      )}
      <ul
        style={{
          listStyle: "none",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          marginBottom: 24,
          padding: 0,
        }}
      >
        {b.modules.map((m, i) => (
          <li key={i} style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <span
              style={{
                fontFamily: "var(--mono)",
                color: "var(--accent)",
                fontSize: 10,
                flex: "0 0 auto",
              }}
            >
              +
            </span>
            <span style={{ fontSize: 12, color: "var(--text)", letterSpacing: "0.02em" }}>{m}</span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className={featured ? "btn btn-primary" : "btn btn-ghost"}
        style={{ width: "100%", justifyContent: "center", fontSize: 11 }}
      >
        Choose {b.name} <span className="btn-arrow">→</span>
      </button>
    </div>
  );
}
